import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/essay/mev-mrv-calculator")({
  beforeLoad: () => {
    throw redirect({ to: "/coaching" });
  },
});
